import { jsx } from 'react/jsx-runtime';
import cx from 'clsx';
import { Facebook, Instagram, Youtube, Tiktok, Telegram } from '@sgcmpteltd/uikit-react';
import { s as styleInject } from './style-inject.es-Bff-fD1R.js';

const SOCIAL_MEDIA_LIST_LAYOUT_NORMAL = 'normal';
const SOCIAL_MEDIA_LIST_LAYOUT_COMPACT = 'compact';
const SOCIAL_MEDIA_ICON_SIZE = 23;

const socialMediaConfigMap = {
    facebook: {
        icon: Facebook,
        iconSize: SOCIAL_MEDIA_ICON_SIZE,
        label: 'Facebook icon',
        url: 'https://www.facebook.com/sgcarmart',
    },
    instagram: {
        icon: Instagram,
        iconSize: SOCIAL_MEDIA_ICON_SIZE,
        label: 'Instagram icon',
        url: 'https://www.instagram.com/sgcarmart/?hl=en',
    },
    youtube: {
        icon: Youtube,
        iconSize: SOCIAL_MEDIA_ICON_SIZE,
        label: 'Youtube icon',
        url: 'https://www.youtube.com/user/SGCMVids',
    },
    tiktok: {
        icon: Tiktok,
        iconSize: SOCIAL_MEDIA_ICON_SIZE,
        label: 'Tiktok icon',
        url: 'https://www.tiktok.com/@sgcarmart',
    },
    telegram: {
        icon: Telegram,
        iconSize: SOCIAL_MEDIA_ICON_SIZE,
        label: 'Telegram icon',
        url: 'https://t.me/sgcmcommunity',
    },
};
const layoutConfigMap = {
    [SOCIAL_MEDIA_LIST_LAYOUT_NORMAL]: {
        className: 'isNormal',
    },
    [SOCIAL_MEDIA_LIST_LAYOUT_COMPACT]: {
        className: 'isCompact',
    },
};

var css_248z = ".SGCM_UIKIT_NEXT_SocialMediaList_listSocialMedia_12ily_1 {\n  display: flex;\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n.SGCM_UIKIT_NEXT_SocialMediaList_listSocialMedia_12ily_1.SGCM_UIKIT_NEXT_SocialMediaList_isNormal_12ily_7 {\n  column-gap: 20px;\n}\n.SGCM_UIKIT_NEXT_SocialMediaList_listSocialMedia_12ily_1.SGCM_UIKIT_NEXT_SocialMediaList_isCompact_12ily_10 {\n  column-gap: 17px;\n}\n\n.SGCM_UIKIT_NEXT_SocialMediaList_linkSocialMedia_12ily_14 {\n  display: block;\n  color: #333333;\n  font-size: 0;\n}\n\n.SGCM_UIKIT_NEXT_SocialMediaList_linkSocialMedia_12ily_14:hover {\n  opacity: 0.6;\n}\n\n.SGCM_UIKIT_NEXT_SocialMediaList_iconSocialMedia_12ily_24 {\n  color: gray;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQWE7RUFDYixVQUFVO0VBQ1YsU0FBUztFQUNULHFCQUFxQjtBQUN2QjtBQUNBO0VBQ0UsZ0JBQWdCO0FBQ2xCO0FBQ0E7RUFDRSxnQkFBZ0I7QUFDbEI7O0FBRUE7RUFDRSxjQUFjO0VBQ2QsY0FBYztFQUNkLFlBQVk7QUFDZDs7QUFFQTtFQUNFLFlBQVk7QUFDZDs7QUFFQTtFQUNFLFdBQVc7QUFDYiIsImZpbGUiOiJzdHlsZXMubW9kdWxlLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubGlzdFNvY2lhbE1lZGlhIHtcbiAgZGlzcGxheTogZmxleDtcbiAgcGFkZGluZzogMDtcbiAgbWFyZ2luOiAwO1xuICBsaXN0LXN0eWxlLXR5cGU6IG5vbmU7XG59XG4ubGlzdFNvY2lhbE1lZGlhLmlzTm9ybWFsIHtcbiAgY29sdW1uLWdhcDogMjBweDtcbn1cbi5saXN0U29jaWFsTWVkaWEuaXNDb21wYWN0IHtcbiAgY29sdW1uLWdhcDogMTdweDtcbn1cblxuLmxpbmtTb2NpYWxNZWRpYSB7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBjb2xvcjogIzMzMzMzMztcbiAgZm9udC1zaXplOiAwO1xufVxuXG4ubGlua1NvY2lhbE1lZGlhOmhvdmVyIHtcbiAgb3BhY2l0eTogMC42O1xufVxuXG4uaWNvblNvY2lhbE1lZGlhIHtcbiAgY29sb3I6IGdyYXk7XG59Il19 */";
var styles = {"listSocialMedia":"SGCM_UIKIT_NEXT_SocialMediaList_listSocialMedia_12ily_1","isNormal":"SGCM_UIKIT_NEXT_SocialMediaList_isNormal_12ily_7","isCompact":"SGCM_UIKIT_NEXT_SocialMediaList_isCompact_12ily_10","linkSocialMedia":"SGCM_UIKIT_NEXT_SocialMediaList_linkSocialMedia_12ily_14","iconSocialMedia":"SGCM_UIKIT_NEXT_SocialMediaList_iconSocialMedia_12ily_24"};
styleInject(css_248z);

const SocialMediaList = ({ layout }) => (jsx("ul", { className: cx(styles.listSocialMedia, styles[layoutConfigMap[layout].className]), children: Object.entries(socialMediaConfigMap)
        .map(([socialMedia, { url, icon: SocialMediaIcon, iconSize, label, },]) => (jsx("li", { children: jsx("a", { "aria-label": label, className: styles.linkSocialMedia, href: url, rel: "noreferrer noopener", target: "_blank", children: jsx(SocialMediaIcon, { size: iconSize }) }) }, socialMedia))) }));

export { SocialMediaList as S, SOCIAL_MEDIA_LIST_LAYOUT_COMPACT as a, SOCIAL_MEDIA_LIST_LAYOUT_NORMAL as b };
//# sourceMappingURL=component-UqVqSYlo.js.map
